//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export enum DealerReport {
    ReportA = 0,
    ReportB = 1,
    ReportC = 2,
    ReportD = 3,
    ReportDD = 4,
    ReportE = 5,
    ReportF = 6,
    ReportG = 7,
    ReportH = 8,
    ReportI = 9,
    ReportJ = 10,
}

export interface InputCreateTempPurchaseOrderQuote {
    quoteId: string;
    branchId: string;
}

export interface InputGenerateQuoteReport {
    quoteId: string;
    isInternalReport: boolean;
}

export interface InputGenerateReport {
    id: string;
    dealerReport: DealerReport;
}

export interface InputIssuePurchaseOrder {
    quoteId: string;
    branchId: string;
    projectId: string;
    purchaseOrderId: string;
}

export interface InputIssueQuote {
    quoteId: string;
    branchId: string;
    projectId: string;
}

export interface InputPreviewQuoteShopDrawing {
    branchId: string;
    projectId: string;
    quoteId: string;
}

export interface ResultCreateTempPurchaseOrderQuote {
    quoteCommonId: string;
}

export interface ResultCreateTempPurchaseOrderQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateTempPurchaseOrderQuote | null;
}

export interface ResultVoid {
}

export interface ResultVoidServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultVoid | null;
}

export interface ServiceResponseError {
    message: string;
    stackTrace: string | null;
}

export enum ServiceResponseType {
    None = 0,
    Ok = 1,
    NotFound = 2,
    UnAuthenticated = 4,
    UnAuthorized = 8,
    Error = 16,
    TransientDbError = 32,
    ValidationFailure = 64,
    ModifyNotFound = 128,
}